module.exports = __webpack_public_path__ + "img/wave_home_red.8ad1b14f.svg";